// Thin router — picks Mobile vs Desktop variant. All shared logic in useStyleOutfit().
import { useIsMobile } from "@/hooks/use-mobile";
import { useStyleOutfit } from "./style-outfit/useStyleOutfit";
import { StyleOutfitMobile } from "./style-outfit/StyleOutfitMobile";
import { StyleOutfitDesktop } from "./style-outfit/StyleOutfitDesktop";

const StyleOutfit = () => {
  const isMobile = useIsMobile();
  const ctx = useStyleOutfit();
  return isMobile ? <StyleOutfitMobile {...ctx} /> : <StyleOutfitDesktop {...ctx} />;
};

export default StyleOutfit;
